import { ContentCluster } from '@app/components/base/content-structure/ContentCluster';
import { FormActionsMui } from '@app/components/form/actions/FormActionsMui';
import { FormArrayItem } from '@app/components/form/array/FormArrayItem';
import { Stack } from '@mui/material';
import { useIntl } from 'react-intl';
import { fragmentsManageMessages } from '../../fragments-manage-messages';
import { TagGroupsFormValues } from '../types';
import { TagGroupContent } from './TagGroupContent';

/** Field array + save actions for the tag groups form. */
export function TagGroupsFormContent() {
  const { $t } = useIntl();

  return (
    <Stack spacing={3}>
      <ContentCluster message={fragmentsManageMessages.tagGroupsTitle} divider={false}>
        <FormArrayItem<TagGroupsFormValues>
          name="tagGroups"
          defaultItem={{
            name: '',
            tags: [],
            default: false,
          }}
          deleteConfirmation={{
            title: $t({
              id: 'admin.tagGroups.deleteGroupTitle',
              defaultMessage: 'Eliminar grupo',
            }),
            description: () =>
              $t({
                id: 'admin.tagGroups.deleteGroupConfirm',
                defaultMessage: '¿Estás seguro que deseas eliminar el grupo?',
              }),
          }}
          getItemDisplayName={(item) =>
            item?.name ||
            $t({
              id: 'admin.tagGroups.newGroupName',
              defaultMessage: 'Nuevo grupo',
            })
          }
          renderItem={({ index }) => <TagGroupContent index={index} />}
        />
      </ContentCluster>

      <FormActionsMui
        saveLabel={$t({
          id: 'common.actions.save',
          defaultMessage: 'Guardar',
        })}
      />
    </Stack>
  );
}
